import { Box, Button, styled } from "@mui/material"
import { DateRange } from "react-date-range"

export const CustomDateRange = styled(DateRange)(({ theme }) => ({
  "& .rdrInfiniteMonths": {
    overflowY: "hidden",
  },
}))

export const ButtonWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  gap: "20px",
  padding: "2%",
  backgroundColor: "white",
}))

export const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  flex: 1,
}))
